import React from 'react';

import {motion} from 'framer-motion'

import {fadeIn} from '../variants'

import img1 from '../assets/portfolio-img1.png'
import img2 from '../assets/portfolio-img2.png'
import img3 from '../assets/portfolio-img3.png'
const Work = () => {
  function handleClick(){
    window.location.href = 'https://github.com/vishesh-hue';

  }
  return <section className='section' id='work' >
    <div className='container mx-auto'>
    <motion.div
    variants={fadeIn('up' ,0.3)}
    initial='hidden'
    whileInView={'show'}
    viewport={{once:false , amount: 0.3}}
    
    className='flex flex-col lg:flex-row gap-x-10'>
      <motion.div
      variants={fadeIn('left' ,0.3)}
      initial='hidden'
      whileInView={'show'}
      viewport={{once:false , amount: 0.3}}
      className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>

      <div>
        <h2 className='h2 leading-tight text-accent'>
          My Latest <br/> Work
        </h2>
        <p className='max-w-sm mb-16'>
          
        </p>
         <button onClick={handleClick} className='btn btn-sm'> view all Projects</button>
       
        </div>

      <div className='group relative overflow-hidden border-2 border-white/50 rounded-x1'>
        <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'> </div>
        <img className='group-hover:scale-125 transition-all duration-500' src={img1}></img>
        <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
          <span className='text-gradient'> FUll stack</span></div>
        <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'><span className='text-3xl text-white'>VTfood-app</span></div>
      </div>
      </motion.div>
      <motion.div className='flex-1 flex flex-col gap-y-10 '>
      <div className='group relative overflow-hidden border-2 border-white/50 rounded-x1'>
        <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'> </div>
        <img className='group-hover:scale-125 transition-all duration-500' src={img2}></img>
        <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
          <span className='text-gradient'> API Integrated</span></div>
        <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'><span className='text-3xl text-white'>Watch-HIT</span></div>
      </div>
      <div className='group relative overflow-hidden border-2 border-white/50 rounded-x1'>
        <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'> </div>
        <img className='group-hover:scale-125 transition-all duration-500' src={img3}></img>
        <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
          <span className='text-gradient'> dev-ops</span></div>
        <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'><span className='text-3xl text-white'>terraform</span></div>
      </div>
      </motion.div>
    </motion.div>
    </div>
  </section>;
};

export default Work;
